// Grid.jsx or Grid.tsx
import { animated } from '@react-spring/web';
import React, { forwardRef } from 'react';
import './action.scss';

const Grid = forwardRef(({ children, columns = 2, gap = '1rem', minWidth = '200px', responsive = true, animation }, ref) => {
  const style = {
    gap,
    gridTemplateColumns: responsive ? `repeat(auto-fill, minmax(${minWidth}, 1fr))` : `repeat(${columns}, 1fr)`,
    ...animation,
  };

  return (
    <animated.div ref={ref} className='grid_wrapper' style={style}>
      {children}
    </animated.div>
  );
});

export default Grid;
